import { useMemo } from "react";
import { useTemplateFieldIsVisible } from "./useTemplateFieldIsVisible";
/**
 * Filters template pages down to those currently visible, honoring the
 * "visibilityFilterPage" marker field on each page.
 *
 * Shared so that page rendering (TemplateForm) and the URL/step labels
 * (RoutePageProvider, via renderTemplate) derive the same visible set from a
 * single definition and cannot drift apart - a mismatch makes TemplateForm
 * override the routing provider with a non-routing one and freezes the URL.
 */
export function useVisiblePages(pages, disablePageVisibilityFilter) {
    const isTemplateFieldVisible = useTemplateFieldIsVisible({
        ignoreRoles: true
    });
    return useMemo(() => pages.filter(p => {
        if (disablePageVisibilityFilter)
            return true;
        const firstField = p.panels.main?.sections[0]?.fields[0];
        if (!!firstField && firstField.role === "visibilityFilterPage")
            return isTemplateFieldVisible(firstField);
        return true;
    }), [pages, disablePageVisibilityFilter, isTemplateFieldVisible]);
}
//# sourceMappingURL=useVisiblePages.js.map